export default {
	title: 'Obchodník',
	ppz: 'Podobchodník',
	subheader: 'Podobchodníci v kampani',
	contacts: 'Kontakty obchodníka',
};
